import React from "react";

import classnames from "classnames";
import find from "lodash/find";
import PropTypes from "prop-types";

import { Text } from "components/ui/source";

import { IconGroup, IconSunny } from "icons";

import styles from "./CollectionCallout.module.scss";

function CollectionCallout({ className, ltsBooking }) {
  const i18nPrefixes = [
    [ltsBooking, "components.bookingWidget.callout.ltsBooking"],
    [true, "components.bookingWidget.callout.cancellation"],
  ];
  const [, i18nPrefix] = find(i18nPrefixes, ([flag]) => flag);
  const icons = [
    [ltsBooking, IconGroup],
    [true, IconSunny],
  ];
  const [, Icon] = find(icons, ([flag]) => flag);
  const refundType = !ltsBooking ? "Cash" : "";

  return (
    <div className={classnames(styles.container, className)}>
      <Icon className={styles.icon} size="xl" color="deep-green" />
      <div className={styles.text_group}>
        <Text
          className={styles.title}
          element="span"
          translateKey={`${i18nPrefix}.title`}
          types={["caption1", "medium"]}
        />
        <Text
          className={styles.description}
          element="span"
          types={["caption1"]}
          translateKey={`${i18nPrefix}.description${refundType}`}
        />
      </div>
    </div>
  );
}

CollectionCallout.propTypes = {
  className: PropTypes.string,
  ltsBooking: PropTypes.bool,
};

export default CollectionCallout;
